import axios, {AxiosResponse} from 'axios'
import {
  AnyQueryResponse,
  CatalogueQueryResponse,
  CataloguesQueryResponse,
  CentreQueryResponse,
  ClientAcomptesQueryResponse,
  ClientAdresseQueryResponse,
  ClientAdressesQueryResponse,
  ClientContactQueryResponse,
  ClientDemandeQueryResponse,
  ClientDemandesQueryResponse,
  ClientDocumentQueryResponse,
  ClientDocumentsQueryResponse,
  ClientEncoursQueryResponse,
  ClientOtherDataQueryResponse,
  ClientQueryResponse,
  CommentaireClientDemandeQueryResponse,
  CourrielQueryResponse,
  DemandeDemontageQueryResponse,
  DemandeDemontageResponse,
  DemandeTransfertVehiculeQueryResponse,
  GenreQueryResponse,
  ImmatriculationQueryResponse,
  ModelActionDemandeTransfert,
  ModeleArticle,
  ModeleCatalogue,
  ModeleCentre,
  ModeleClient,
  ModeleClientAdresse,
  ModeleClientContact,
  ModeleClientDemande,
  ModeleClientDemandePiece,
  ModeleClientDocument,
  ModeleClientRemise,
  ModeleCommentaireClientDemande,
  ModeleCourriel,
  ModeleDelaisTraitement,
  ModeleDemandeDemontage,
  ModeleDepot,
  ModeleGenre,
  ModeleHistoriqueFacturationResponse,
  ModeleLibelleDemandePiece,
  ModeleMesActions,
  ModeleMotif,
  ModeleProvenance,
  ModeleRechercheCatalogue,
  ModeleReferentielFournisseurPOT,
  ModeleReferentielTypePiece,
  ModeleRemise,
  ModeleReseauClient,
  ModeleRole,
  ModeleRoleAndModules,
  ModeleServiceRattachement,
  ModeleTransfertStatutVehicule,
  ModeleTypeAction,
  ModeleUtilisateur,
  ModulesQueryResponse,
  RechercheCatalogueQueryResponse,
  ReferentielTypePieceQueryResponse,
  RemiseGroupeClientResponse,
  RemiseQueryResponse,
  ReseauClientQueryResponse,
  RoleQueryResponse,
  RolesQueryResponse,
  StatutActionsQueryResponse,
  TypeActionsQueryResponse,
  UtilisateurQueryResponse,
  UtilisateursQueryResponse,
} from './Models'
import {Response} from '../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL
const CLIENT_BASE_URL = `${API_URL}/client`
const CLIENT_SOURCE_BASE_URL = `${API_URL}/client-siren`
const DEMANDE_BASE_URL = `${API_URL}/demande`
const UTILISATEUR_BASE_URL = `${API_URL}/utilisateur`
const PIECE_BASE_URL = `${API_URL}/piece`
const CENTRE_BASE_URL = `${API_URL}/centre`
const GENRE_BASE_URL = `${API_URL}/vehicule-type`
const ROLE_BASE_URL = `${API_URL}/utilisateur-role`
const ACOMPTE_BASE_URL = `${API_URL}/client-acompte`
const CLIENT_DOCUMENT_BASE_URL = `${API_URL}/client-document`
const CLIENT_DEMANDE_ETAPE_BASE_URL = `${API_URL}/client_demande_etape`
const DEMANDE_SOURCE_BASE_URL = `${API_URL}/client-demande-source`
const ACCESS_DENIED_BASE_URL = `/error/access-denied`
const COURRIEL_BASE_URL = `${API_URL}/mail-client`
const DEMANDE_IMMAT_BASE_URL = `${API_URL}/demande/immat`
const KPI_DEMANDE_BASE_URL = `${API_URL}/getDataKpiDemande`
const REMISE_GROUPE_BASE_URL = `${API_URL}/remise/groupe`
const MOTIF_REFUS_BASE_URL = `${API_URL}/motif-refus`
const CLIENT_GROUPE_BASE_URL = `${API_URL}/client/groupe`
const VEHICULE_BASE_URL = `${API_URL}/vehicule`
const COMMENTAIRE_CLIENT_DEMANDE_BASE_URL = `${API_URL}/commentaire-client-demande`
const REFERENCEMENT_TYPE_PIECE_BASE_URL = `${API_URL}/referencement/type_piece`
const VEHICULE_MODELE_BASE_URL = `${API_URL}/vehicule/modele`
const CLIENT_DUPLICATE_CHECK_URL = `${API_URL}/client/check-duplicate`
const RESULTAT_AI_URL = `${API_URL}/resultat-ai-piece`
const DEMANDE_DEMONTAGE_BASE_URL = `${API_URL}/demande-demontage`
const DEMONTAGE_STATUT_BASE_URL = `${API_URL}/demontage-statut`
const DEMANDE_TRANSFERT_STATUT_BASE_URL = `${API_URL}/demande-transfert`
const TYPE_PIECE_BASE_URL = `${API_URL}/type/piece`
const HISTORIQUE_DEMONTAGE_BASE_URL = `${API_URL}/historique-entity`
const TYPE_PIECE_POT_BASE_URL = `${API_URL}/type-piece-pot`
const REFERENTIEL_FOURNISSEUR_POT_BASE_URL = `${API_URL}/fournisseur-pot`
const CLIENT_DEMANDE_MESSAGE = `${API_URL}/demande/message`
const RESEAU_CLIENT_BASE_URL = `${API_URL}/reseauClient`
const TYPE_DELAIS_TRAITEMENT = `${API_URL}/type_delai_traitement_demande`
const DELAIS_TRAITEMENT = `${API_URL}/delaiTraitementDemande`
const MES_ACTIONS_BASE_URL = `${API_URL}/mes-actions`
const TYPE_ACTIONS_BASE_URL = `${API_URL}/type-action`
const STATUT_ACTIONS_BASE_URL = `${API_URL}/statut-action`
const PRIX_MODIF_BASE_URL = `${API_URL}/modification-prix`
const PIECE_MARCHE_BASE_URL = `${API_URL}/piece-marche`
const ANOMALIE_POT_BASE_URL = `${API_URL}/anomalie-pot`
const TYPE_LIBELLE_DEMANDE = `${API_URL}/type-libelle-demande`
const LIBELLE_DEMANDE_PIECE = `${API_URL}/libelle-demande-piece`
const PROVENANCES_PIECE = `${API_URL}/provenance-piece`
const SOURCE_BASE_URL = `${API_URL}/source`
const PIECE_COMMENTAIRE = `${API_URL}/piece-proposee/commentaire`
const CLIENT_DEMANDE_PIECE_PROPOSEE = `${API_URL}/demande/piece/proposee`
const EQUIPES_URL = `${API_URL}/equipe`
const DEPOT_URL = `${API_URL}/depot`
const PAIEMENT_BASE_URL = `${API_URL}/paiement`
const FILTER_BASE_URL = `${API_URL}/filter-favoris`
const MODIF_PRIX_FILTER_BASE_URL = `${API_URL}/modif-prix-favoris`
const SERVICE_RATTACHEMENT_URL = `${API_URL}/service-rattachement`
const GROUPE_LIBPR_URL = `${API_URL}/groupe-libpr`

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response) {
      const {code, message} = error.response.data

      if (code == 500 && message == 'Access denied to this fonctionnalite') {
        window.location.href = ACCESS_DENIED_BASE_URL
      }
    }
    return Promise.reject(error)
  }
)

export const getCatdata = async (
  immatriculation: string | undefined
): Promise<ImmatriculationQueryResponse | undefined> => {
  return await axios.get(`${API_URL}/catdata?immat=${immatriculation}`)
}
export const getCatdataCnit = async (
  cnit: string | undefined
): Promise<ImmatriculationQueryResponse | undefined> => {
  return await axios.get(`${API_URL}/catdataCnit?cnit=${cnit}`)
}

export const getShopToken = async (): Promise<Response<string>> => {
  return await axios.get(`${API_URL}/shop_token`)
}

export const getUtilisateurs = async (page, search): Promise<any> => {
  const response = await axios.get(`${UTILISATEUR_BASE_URL}?page=${page}&search=${search}`)
  return response.data
}

export const getUtilisateursWithoutPagination = async (): Promise<UtilisateursQueryResponse> => {
  return await axios.get(`${UTILISATEUR_BASE_URL}/without-pagination`)
}

export const getUtilisateur = async (utilisateurId: string | undefined): Promise<any> => {
  return await axios.get(`${UTILISATEUR_BASE_URL}/${utilisateurId}`)
}

export const createUtilisateur = async (
  utilisateur: ModeleUtilisateur
): Promise<UtilisateurQueryResponse | undefined> => {
  return await axios.post(UTILISATEUR_BASE_URL, utilisateur)
}

export const editUtilisateur = async (
  utilisateurId: string | undefined,
  utilisateur: ModeleUtilisateur
): Promise<UtilisateurQueryResponse | undefined> => {
  return await axios.post(`${UTILISATEUR_BASE_URL}/${utilisateurId}/edit`, utilisateur)
}

export const deleteUtilisateur = async (
  utilisateurId: string | undefined
): Promise<UtilisateurQueryResponse | undefined> => {
  return await axios.delete(`${UTILISATEUR_BASE_URL}/${utilisateurId}/delete`)
}

export const getClients = async (page, search, statut, type): Promise<any> => {
  const response = await axios.get(
    `${CLIENT_BASE_URL}?page=${page}&search=${search}&statut=${statut}&type=${type}`
  )
  return response.data
}

export const getClientSources = async (
  page,
  searchNomClient,
  searchSiren,
  searchSiret,
  clientActif,
  searchCodeClient
): Promise<any> => {
  const response = await axios.get(
    `${CLIENT_SOURCE_BASE_URL}?page=${page}&nomClient=${searchNomClient}&siren=${searchSiren}&siret=${searchSiret}&clientActif=${clientActif}&codeClient=${searchCodeClient}`
  )
  return response.data
}

export const getClientSource = async (clientSourceId: string | undefined): Promise<any> => {
  return await axios.get(`${CLIENT_SOURCE_BASE_URL}/${clientSourceId}`)
}

export const getClientSourcesEtablissements = async (
  page,
  clientId: string | undefined,
  actif,
  searchSiret
): Promise<any> => {
  const response = await axios.get(
    `${CLIENT_SOURCE_BASE_URL}/${clientId}/etablissement?page=${page}&actif=${actif}&siret=${searchSiret}`
  )
  return response.data
}

export const getAllClients = async (): Promise<any> => {
  const response = await axios.get(`${CLIENT_BASE_URL}`)
  return response.data
}

export const getClient = async (
  clientId: string | number | undefined
): Promise<ClientQueryResponse> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}`)
}

export const getClientOtherData = async (
  clientId: string | number | null | undefined,
  demandeId: number | string | undefined | null
): Promise<ClientOtherDataQueryResponse> => {
  if (demandeId == null) {
    return await axios.get(`${CLIENT_BASE_URL}/${clientId}/others`)
  } else {
    return await axios.get(`${CLIENT_BASE_URL}/${clientId}/others`, {
      params: {
        demandeId,
      },
    })
  }
}

export const createClient = async (
  client: ModeleClient
): Promise<ClientQueryResponse | undefined> => {
  return await axios.post(CLIENT_BASE_URL, client)
}

export const editClient = async (
  clientId: string | undefined,
  client: ModeleClient
): Promise<ClientQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/edit`, client)
}

export const getLastClientId = async (): Promise<any> => {
  return await axios.get(`${CLIENT_BASE_URL}/lastId`)
}

export const getClientContacts = async (clientId: string | undefined | number): Promise<any> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}/contacts`)
}

export const getClientContact = async (
  clientId: string | undefined,
  contactId: string | undefined
): Promise<ClientContactQueryResponse> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}/contact/${contactId}`)
}

export const createClientContact = async (
  clientId: string | undefined,
  contact: ModeleClientContact
): Promise<ClientContactQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/contact`, contact)
}

export const editClientContact = async (
  clientId: string | undefined,
  contactId: string | undefined,
  contact: ModeleClientContact
): Promise<ClientContactQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/contact/${contactId}`, contact)
}

export const deleteClientContact = async (
  clientId: string | number | undefined,
  contactId: string | undefined
): Promise<ClientContactQueryResponse | undefined> => {
  return await axios.delete(`${CLIENT_BASE_URL}/${clientId}/contact/${contactId}`)
}

export const getClientAdresses = async (
  clientId: string | number | undefined
): Promise<ClientAdressesQueryResponse> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}/adresses`)
}

export const getClientAdresse = async (
  clientId: string | undefined,
  adresseId: string | undefined
): Promise<ClientAdresseQueryResponse> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}/adresse/${adresseId}`)
}

export const createClientAdresse = async (
  clientId: string | undefined,
  adresse: ModeleClientAdresse
): Promise<ClientAdresseQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/adresse`, adresse)
}

export const editClientAdresse = async (
  clientId: string | undefined,
  adresseId: string | undefined,
  adresse: ModeleClientAdresse
): Promise<ClientAdresseQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/adresse/${adresseId}`, adresse)
}

export const deleteClientAdresse = async (
  clientId: string | number | undefined,
  adresseId: string | undefined
): Promise<ClientAdresseQueryResponse | undefined> => {
  return await axios.delete(`${CLIENT_BASE_URL}/${clientId}/adresse/${adresseId}`)
}

export const getClientDemandes = async (
  clientId: string | number | undefined
): Promise<ClientDemandesQueryResponse> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}/demandes`)
}

export const getDemandes = async (
  page: any,
  search: any,
  statut: any,
  statusMode: string,
  source: any,
  clientId: number | null | undefined,
  dateDebut: string | null,
  dateFin: string | null,
  demandeEquipe: any | null,
  userConnectedCentres: string | null,
  idDemande: number | string | null | undefined,
  allDemandes: boolean | null | undefined,
  searchId: number | string | null,
  tri: string,
  itemPerPage: number,
  signal?: AbortSignal
): Promise<any> => {
  if (clientId == null) {
    return await axios.get(DEMANDE_BASE_URL, {
      params: {
        page,
        search,
        statut,
        statusMode,
        dateDebut,
        dateFin,
        demandeEquipe,
        userConnectedCentres,
        idDemande,
        source,
        allDemandes,
        searchId,
        itemPerPage,
        tri,
      },
      signal,
    })
  } else {
    return await axios.get(DEMANDE_BASE_URL, {
      params: {
        clientId,
        page,
        search,
        statut,
        dateDebut,
        dateFin,
        demandeEquipe,
        userConnectedCentres,
        idDemande,
        source,
        allDemandes,
        searchId,
        itemPerPage,
        tri,
      },
      signal,
    })
  }
}

export const getDemandesWithoutPagination = async (search: any): Promise<AnyQueryResponse> => {
  return await axios.get(`${DEMANDE_BASE_URL}/without-pagination?search=${search}`)
}

export const getTopReferencePiece = async (): Promise<any> => {
  return await axios.get(`${DEMANDE_BASE_URL}/piece/rechercher`)
}

export const deleteDemande = async (demandeId): Promise<any> => {
  return axios.delete(`${DEMANDE_BASE_URL}/${demandeId}`)
}

export const checkDemandeAlreadyAssigned = async (
  idDemande: string | undefined | number | null
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_BASE_URL}/${idDemande}/check-demande-assigned`)
}

export const getClientDemandeImmat = async (
  demandeId: string | number | undefined,
  userConnectedCentres?: string | null | undefined
): Promise<any> => {
  if (userConnectedCentres !== null && userConnectedCentres !== undefined) {
    return await axios.get(
      `${API_URL}/demande/immat/${demandeId}?userConnectedCentres=${userConnectedCentres}`
    )
  } else {
    return await axios.get(`${API_URL}/demande/immat/${demandeId}`)
  }
}

export const postClientDemandeAssign = async (
  clientId: string | undefined | null,
  demandeId: string | undefined | null,
  userId: number | null
): Promise<ClientDemandeQueryResponse> => {
  if (userId) {
    return await axios.post(`${CLIENT_BASE_URL}/${clientId}/demande/${demandeId}/assign`, {
      user: userId,
    })
  } else {
    return await axios.post(`${CLIENT_BASE_URL}/${clientId}/demande/${demandeId}/assign`, {})
  }
}

export const generateDevisPdf = async (
  panier: string | undefined | null,
  libelles: string | undefined | null,
  demandeId: number | null,
  dataClientInfos: any,
  dataVehicule: any,
  otherData: any,
  adresseFacturation: any,
  sources: any,
  transpOffert: boolean,
  signal?: AbortSignal
): Promise<any> => {
  return await axios.post(
    `${DEMANDE_BASE_URL}/generateDevisPdf`,
    {
      panier: panier,
      libelles: libelles,
      demandeId: demandeId,
      dataClientInfos: dataClientInfos,
      dataVehicule: dataVehicule,
      otherData: otherData,
      adresseFacturation: adresseFacturation,
      transpOffert: transpOffert,
      sources: sources,
    },
    {signal}
  )
}

export const getDemandeDevis = async (demandeDevis: string): Promise<any> => {
  return await axios.get(`${DEMANDE_BASE_URL}/devis/${demandeDevis}`)
}

export const getAllDemandeDevis = async (demandeId: string): Promise<any> => {
  return await axios.get(`${DEMANDE_BASE_URL}/historique-devis/${demandeId}`)
}

export const downloadPdf = async (file): Promise<AxiosResponse<ArrayBuffer>> => {
  return axios.get(`${DEMANDE_BASE_URL}/download-pdf-file/${file}`, {
    responseType: 'arraybuffer', // ← OCTETS BRUTS (pas blob ici)
    headers: {
      Accept: 'application/pdf',
    },
  })
}

export const downloadPjSuppl = async (
  pieceJointes: any,
  demandePj: boolean
): Promise<AxiosResponse<ArrayBuffer>> => {
  return axios.post(
    `${DEMANDE_BASE_URL}/pieces-jointe-sup`,
    {
      pieceJointes: pieceJointes,
      demandePj: demandePj,
    },
    {
      responseType: 'arraybuffer',
    }
  )
}

export const downloadImage = async (fileName): Promise<AxiosResponse<ArrayBuffer>> => {
  return axios.get(`${DEMANDE_BASE_URL}/download-imagePot-file/${fileName}`, {
    responseType: 'arraybuffer', // ← OCTETS BRUTS (pas blob ici)
    headers: {
      Accept: 'application/octet-stream',
    },
  })
}

export const downloadPdfClientSide = async (
  url,
  typeOfFile
): Promise<AxiosResponse<ArrayBuffer>> => {
  return axios.get(url, {
    responseType: 'arraybuffer', // ← OCTETS BRUTS (pas blob ici)
    headers: {
      Accept: typeOfFile,
    },
  })
}

export const downloadPdfSuggestion = async (file): Promise<AxiosResponse<ArrayBuffer>> => {
  return axios.get(`${API_URL}/suggestion/pdf/devis/download/${file}`, {
    responseType: 'arraybuffer', // ← OCTETS BRUTS (pas blob ici)
    headers: {
      Accept: 'application/pdf',
    },
  })
}

export const downloadPjSupplSuggestion = async (
  pieceJointes: any
): Promise<AxiosResponse<ArrayBuffer>> => {
  return axios.post(
    `${API_URL}/suggestion/pieces-jointe-sup`,
    {
      pieceJointes: pieceJointes,
    },
    {
      responseType: 'arraybuffer',
    }
  )
}

export const downloadImageSuggestion = async (fileName): Promise<AxiosResponse<ArrayBuffer>> => {
  return axios.get(`${API_URL}/suggestion/images/pot/download/${fileName}`, {
    responseType: 'arraybuffer', // ← OCTETS BRUTS (pas blob ici)
    headers: {
      Accept: 'application/octet-stream',
    },
  })
}

export const createClientDemande = async (
  clientId: string | undefined,
  demande: ModeleClientDemande,
  pieces: Array<ModeleClientDemandePiece | undefined>
): Promise<ClientDemandeQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/demande`, {
    ...demande,
    pieces: JSON.stringify(pieces),
  })
}

export const getDemandePieceSuggestion = async (
  demandeId: string | undefined,
  demandePieceId: number | undefined
): Promise<Response<string | null>> => {
  return await axios.get(`${PIECE_BASE_URL}/demande/${demandeId}/suggestion/${demandePieceId}`)
}

export const getSearchVehiculeAndPieces = async (
  immatriculation: string | undefined,
  cnit: string | undefined,
  page: number | undefined
): Promise<any | undefined> => {
  if (immatriculation) {
    return await axios.get(`${API_URL}/searchvandp?immatriculation=${immatriculation}&page=${page}`)
  } else if (cnit) {
    return await axios.get(`${API_URL}/searchvandp?cnit=${cnit}&page=${page}`)
  }
}

export const getSearchPiece = async (
  reference: string | undefined,
  referenceVehicule: string | undefined,
  nomenclatureTypePiece: string | undefined,
  signal?: AbortSignal
): Promise<any | undefined> => {
  if (!reference && !referenceVehicule && !nomenclatureTypePiece) {
    console.error('La référence/referenceVehicule/nomenclatureTypePiece undefined ou vide')
    return undefined
  }

  try {
    return await axios.get(
      `${API_URL}/searchp?reference=${reference}&referenceVehicule=${referenceVehicule}&nomenclatureTypePiece=${nomenclatureTypePiece}`,
      {
        signal,
      }
    )
  } catch (error: unknown) {
    if (error instanceof Error) {
      if (error.name === 'AbortError') {
        console.log('Requête annulée')
      } else {
        console.error('Erreur lors de la récupération des données :', error.message)
      }
    } else {
      console.error('Erreur inconnue')
    }
    return undefined
  }
}

export const getCompanyBySiret = async (siret: string): Promise<any> => {
  const response = await axios.post(`${CLIENT_BASE_URL}/getInfoCompanyViaSiret`, {siret})
  return response.data
}

export const createCentre = async (
  centre: ModeleCentre
): Promise<CentreQueryResponse | undefined> => {
  return await axios.post(CENTRE_BASE_URL, centre)
}

export const getCentres = async (
  page,
  search,
  userConnectedCentres?: string | null | undefined
): Promise<any> => {
  let response
  if (userConnectedCentres !== null && userConnectedCentres !== undefined) {
    response = await axios.get(
      `${CENTRE_BASE_URL}?page=${page}&search=${search}&userConnectedCentres=${userConnectedCentres}`
    )
  } else {
    response = await axios.get(`${CENTRE_BASE_URL}?page=${page}&search=${search}`)
  }
  return response.data
}

export const getCentreAll = async (): Promise<any> => {
  const response = await axios.get(`${CENTRE_BASE_URL}/all`)
  return response.data
}

export const getCentre = async (centreId: string | undefined): Promise<CentreQueryResponse> => {
  return await axios.get(`${CENTRE_BASE_URL}/${centreId}`)
}

export const editCentre = async (
  centreId: string | undefined,
  centre: ModeleCentre
): Promise<CentreQueryResponse | undefined> => {
  return await axios.post(`${CENTRE_BASE_URL}/${centreId}/edit`, centre)
}

export const deleteCentre = async (
  centreId: string | undefined
): Promise<CentreQueryResponse | undefined> => {
  return await axios.delete(`${CENTRE_BASE_URL}/${centreId}/delete`)
}
export const createGenre = async (genre: ModeleGenre): Promise<GenreQueryResponse | undefined> => {
  return await axios.post(GENRE_BASE_URL, genre)
}

export const getGenres = async (page, search): Promise<any> => {
  const response = await axios.get(`${GENRE_BASE_URL}?page=${page}&search=${search}`)
  return response.data
}

export const createMotif = async (motif: ModeleMotif): Promise<any> => {
  return await axios.post(MOTIF_REFUS_BASE_URL, motif)
}

export const getRefusMotif = async (page): Promise<any> => {
  const response = await axios.get(`${MOTIF_REFUS_BASE_URL}?page=${page}`)
  return response.data
}

export const getAllRefusMotif = async (): Promise<any> => {
  return await axios.get(`${MOTIF_REFUS_BASE_URL}/all-motifs`)
}

export const getOneMotif = async (id: number | string | undefined): Promise<any> => {
  return await axios.get(`${MOTIF_REFUS_BASE_URL}/${id}`)
}

export const editMotif = async (
  motifId: number | string | undefined,
  modelRefus: ModeleMotif
): Promise<any> => {
  return await axios.post(`${MOTIF_REFUS_BASE_URL}/${motifId}/edit`, modelRefus)
}

export const deleteMotif = async (motifId: number | string | undefined): Promise<any> => {
  return await axios.delete(`${MOTIF_REFUS_BASE_URL}/${motifId}/delete`)
}

export const editGenre = async (
  genreId: string | undefined,
  genre: ModeleGenre
): Promise<GenreQueryResponse | undefined> => {
  return await axios.post(`${GENRE_BASE_URL}/${genreId}/edit`, genre)
}

export const deleteGenre = async (
  genreId: string | undefined
): Promise<GenreQueryResponse | undefined> => {
  return await axios.delete(`${GENRE_BASE_URL}/${genreId}/delete`)
}

export const getGenre = async (genreId: string | undefined): Promise<GenreQueryResponse> => {
  return await axios.get(`${GENRE_BASE_URL}/${genreId}`)
}

export const getResultSeach = async (allSearch: string): Promise<any> => {
  const response = await axios.post(`${CLIENT_BASE_URL}/clientSearch`, {allSearch})
  return response.data
}
export const getRoles = async (): Promise<RolesQueryResponse> => {
  return await axios.get(`${ROLE_BASE_URL}`)
}

export const getModules = async (): Promise<ModulesQueryResponse> => {
  return await axios.get(`${API_URL}/module`)
}

export const getRole = async (roleId: string | undefined): Promise<RoleQueryResponse> => {
  return await axios.get(`${ROLE_BASE_URL}/${roleId}`)
}

export const createRole = async (
  role: ModeleRoleAndModules
): Promise<RoleQueryResponse | undefined> => {
  return await axios.post(`${API_URL}/utilisateur-role`, role)
}

export const editRole = async (
  roleId: string | undefined,
  role: ModeleRole
): Promise<RoleQueryResponse | undefined> => {
  return await axios.post(`${ROLE_BASE_URL}/${roleId}/edit`, role)
}

export const getResultSearchUser = async (allSearch: string): Promise<any> => {
  const response = await axios.post(`${UTILISATEUR_BASE_URL}/userSearch`, {allSearch})
  return response.data
}
export const centresearch = async (search: string): Promise<any> => {
  const response = await axios.post(`${CENTRE_BASE_URL}/searchCentre`, {search})
  return response.data
}

export const genreSearch = async (search: string): Promise<any> => {
  const response = await axios.post(`${GENRE_BASE_URL}/vehiculeTypeSearch`, {search})
  return response.data
}

export const deleteRoleUtilisateur = async (
  roleId: string | undefined
): Promise<RoleQueryResponse | undefined> => {
  return await axios.delete(`${ROLE_BASE_URL}/${roleId}/delete`)
}

export const getCatalogues = async (): Promise<CataloguesQueryResponse> => {
  return await axios.get(`${API_URL}/catalogue`)
}

export const getClientEncours = async (
  clientId: string | number | undefined
): Promise<ClientEncoursQueryResponse> => {
  return await axios.get(`${API_URL}/client-encours-paiement/${clientId}`)
}

export const getCatalogue = async (
  idCatalogue: string | undefined
): Promise<CatalogueQueryResponse> => {
  return await axios.get(`${API_URL}/catalogue/${idCatalogue}`)
}

export const createCatalogue = async (
  catalogue: ModeleCatalogue
): Promise<CatalogueQueryResponse | undefined> => {
  return await axios.post(`${API_URL}/catalogue`, catalogue)
}

export const editCatalogue = async (
  idCatalogue: string | undefined,
  catalogue: ModeleCatalogue
): Promise<CatalogueQueryResponse | undefined> => {
  return await axios.post(`${API_URL}/catalogue/${idCatalogue}/edit`, catalogue)
}

export const deleteCatalogue = async (
  idCatalogue: string | undefined
): Promise<CatalogueQueryResponse | undefined> => {
  return await axios.delete(`${API_URL}/catalogue/${idCatalogue}/delete`)
}

export const getSearchPieceRefConst = async (
  reference: string | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(`${PIECE_BASE_URL}/piece_ref_cons?refConst=${reference}`)
}

export const postDemandes = async (
  clientId: string | undefined,
  immatCentre: any,
  immatPieces: any,
  demandeId: any,
  modeleIdArr: any,
  dataHorsType: any = [],
  defaultValueContact: any,
  radioValue: string,
  demandeSource: any,
  contentCommunication: string,
  contactValue: any,
  isAdresseUpdated: any,
  updatedAdresseFactInfo: any,
  updatedAdresseLivInfo: any,
  equipe: any,
  retraitDepot: any,
  pjDemande: any[]
): Promise<any> => {
  const formData = new FormData()

  formData.append('immatCentreArray', JSON.stringify(immatCentre))
  formData.append('demandePieceArray', JSON.stringify(immatPieces))
  formData.append('modeleIdArray', JSON.stringify(modeleIdArr))
  formData.append('dataHorsType', JSON.stringify(dataHorsType))
  formData.append('contactedBy', defaultValueContact)
  formData.append('communication', radioValue)
  formData.append('demandeSource', demandeSource)
  formData.append('contentCommunication', contentCommunication)
  formData.append('contactValue', contactValue)
  formData.append('updateClientAdresse', isAdresseUpdated)
  formData.append('updatedAdresseFac', JSON.stringify(updatedAdresseFactInfo))
  formData.append('updatedAdresseLiv', JSON.stringify(updatedAdresseLivInfo))
  formData.append('equipe', equipe)
  formData.append('retraitDepot', retraitDepot)

  pjDemande.forEach((imgObj) => {
    formData.append('demandePj[]', imgObj.file)
  })

  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/demande`, formData)
}

export const getAllPieceTypePiece = async (): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(`${PIECE_BASE_URL}/all_piece_type_piece`)
}

export const getAllPieceTypePiecesOptions = async (): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(`${PIECE_BASE_URL}/all_piece_type_pieces_options`)
}

export const getSearchPieceTypePiece = async (
  piece_tp: string | undefined,
  code: boolean = false,
  siteVehicule: string | null | undefined = null
): Promise<AnyQueryResponse | undefined> => {
  let param = ''
  if (code) param += `&code=${code}`
  if (siteVehicule) param += `&siteVehicule=${siteVehicule}`

  return await axios.get(`${PIECE_BASE_URL}/piece_type_piece?typePiece=${piece_tp}${param}`)
}

export const editDemandes = async (
  clientId: string | undefined,
  immatCentre: any,
  immatPieces: any,
  demandeId: number,
  modeleIdArray: any = [],
  dataHorsType: any = [],
  defaultValueContact: number,
  radioValue: string,
  demandeSource: any,
  contentCommunication: string,
  contactValue: any,
  updateClientAdresse: any,
  adresseFacturation: any,
  adresseLivraison: any,
  equipe: any,
  retraitDepot: any,
  pjDemande: any
): Promise<any> => {
  const formData = new FormData()

  formData.append('immatCentreArray', JSON.stringify(immatCentre))
  formData.append('demandePieceArray', JSON.stringify(immatPieces))
  formData.append('modeleIdArray', JSON.stringify(modeleIdArray))
  formData.append('dataHorsType', JSON.stringify(dataHorsType))
  formData.append('demandeSource', demandeSource)
  formData.append('contactValue', contactValue)
  formData.append('contentCommunication', contentCommunication)
  formData.append('updateClientAdresse', updateClientAdresse)
  formData.append('updatedAdresseFac', JSON.stringify(adresseFacturation))
  formData.append('updatedAdresseLiv', JSON.stringify(adresseLivraison))
  formData.append('equipe', equipe)
  formData.append('retraitDepot', retraitDepot)

  pjDemande.forEach((imgObj) => {
    formData.append('demandePj[]', imgObj.file?.size ? imgObj.file : JSON.stringify(imgObj.file))
  })

  return await axios.post(`${CLIENT_BASE_URL}/edit/${clientId}/demande/${demandeId}`, formData)
}

export const deleteImmatOnEdit = async (
  clientDemandeImmat: number | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.delete(`${CLIENT_BASE_URL}/delete/demande/${clientDemandeImmat}`)
}

export const getCategoriePiece = async (
  typePieceId: string | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(`${API_URL}/type/piece/${typePieceId}`)
}

/*export const getCentre = async (centre: string | undefined): Promise<AnyQueryResponse | undefined> => {
    return await axios
      .get(`${API_URL}/centre/${centre}`)
}*/

export const getListePieceViaType = async (
  idTypePiece: string | number | undefined,
  page,
  searchRef,
  marque,
  modele,
  isAgregate,
  clientId: string | number | undefined,
  sortField: string | undefined = '',
  sortOrder: string | undefined = '',
  piecePubliable: boolean | undefined = true
): Promise<any> => {
  const response = await axios.get(
    `${PIECE_BASE_URL}/piece_type_piece/${idTypePiece}?page=${page}&reference=${
      searchRef.reference
    }&codePiece=${searchRef.codePiece}&vehicule=${searchRef.codeVehicule}&searchMarque=${
      searchRef.marque
    }&searchModele=${searchRef.modele}&codeMoteur=${searchRef.codeMoteur}&immatriculation=${
      searchRef.immatriculation
    }&marque=${marque}&modele=${modele}&clientId=${clientId}&isAgregate=${isAgregate}&isSearch=${!!searchRef?.isSearch}&sortField=${sortField}&sortOrder=${sortOrder}&piecePubliable=${piecePubliable}`
  )
  return response.data
}

export const getTypePieceStockValue = async (
  idTypePiece: string | number | undefined | null,
  reference,
  marque,
  modele,
  signal?: AbortSignal
): Promise<AnyQueryResponse | undefined> => {
  try {
    return await axios.get(
      `${PIECE_BASE_URL}/piece_type_piece/stock/${idTypePiece}?reference=${reference}&codePiece=&vehicule=&marque=${marque}&modele=${modele}`,
      {signal}
    )
  } catch (error: unknown) {
    if (error instanceof Error) {
      if (error.name === 'AbortError') {
        console.log('Requête annulée')
      } else {
        console.warn('Erreur lors de la récupération des données :', error.message)
      }
    } else {
      console.error('Erreur inconnue')
    }
    return undefined
  }
}

export const getPieceInStock = async (
  idPiece: string | number | undefined,
  idDemande: string | number | undefined,
  idTypePiece: string | number | undefined,
  demandeImmatId: string | number | undefined,
  clientId: string | number | undefined,
  marque: string | undefined,
  modele: string | undefined,
  codeMoteur: string | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(
    `${PIECE_BASE_URL}/piece_in_stock/${idPiece}/${idDemande}/${idTypePiece}/${demandeImmatId}/${clientId}?marque=${marque}&modele=${modele}&codeMoteur=${codeMoteur}`
  )
}

export const getPieceSuggestion = async (
  piecesArr: any | undefined | null,
  clientId: number | string | undefined,
  demandeId: number | string | undefined,
  demandeDevisId?: number | string | undefined,
  source?: string | null | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_BASE_URL}/piece/proposee`, {
    piecesArr: piecesArr,
    clientId: clientId,
    demandeId: demandeId,
    demandeDevisId: demandeDevisId,
    source: source,
  })
}
export const modifPrixImport = async (file: any): Promise<any> => {
  return await axios.post(`${PRIX_MODIF_BASE_URL}/import`, file)
}

export const getModifPrix = async (
  page,
  dateDebut,
  dateFin,
  traitee,
  source,
  searchPage,
  sortOrder,
  sortField,
  libellePiece: string,
  signal?: AbortSignal
): Promise<any | undefined> => {
  try {
    const response = await axios.get(
      `${PRIX_MODIF_BASE_URL}?page=${page}&dateDebut=${dateDebut}&dateFin=${dateFin}&traitee=${traitee}&source=${source}&searchPage=${searchPage}&sortOrder=${sortOrder}&sortField=${sortField}&libellePiece=${encodeURIComponent(
        libellePiece
      )}`,
      {signal}
    )
    return response.data
  } catch (error: unknown) {
    if (error instanceof Error) {
      if (error.name === 'AbortError') {
        console.log('Requête annulée')
      } else {
        console.warn('Erreur lors de la récupération des données :', error.message)
      }
    } else {
      console.error('Erreur inconnue')
    }
    return undefined
  }
}

export const getSyncpiecesprixSd = async (
  checkedModifPrice,
  dateDebut,
  dateFin,
  traitee,
  sourcesSearch,
  searchPage
): Promise<any> => {
  return await axios.post(`${API_URL}/syncpiecesprix`, {
    checkedModifPrice: checkedModifPrice,
    dateDebut: dateDebut,
    dateFin: dateFin,
    traitee: traitee,
    source: sourcesSearch,
    searchPage: searchPage,
  })
}

export const deletePrix = async (idModifPrix): Promise<any> => {
  return await axios.post(`${PRIX_MODIF_BASE_URL}/delete`, {
    idModifPrix: idModifPrix,
  })
}

export const integrationArgus = async (dataRefOe, nouveauPrix, idModifPrix): Promise<any> => {
  return await axios.post(`${PRIX_MODIF_BASE_URL}/integration-argus`, {
    dataRefOe: dataRefOe,
    nouveauPrix: nouveauPrix,
    idModifPrixConcernee: idModifPrix,
  })
}

export const updatePrixTarificationArgus = async (idModifPrix, nouveauPrix): Promise<any> => {
  return await axios.post(`${PRIX_MODIF_BASE_URL}/update`, {
    idModifPrix: idModifPrix,
    nouveauPrix: nouveauPrix,
  })
}

export const postGenreByCode = async (
  code: string | number | undefined | null
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${GENRE_BASE_URL}/code`, {
    code: code,
  })
}

export const postEmailPropos = async (
  panier: any | undefined | null,
  clientId: number | string | undefined,
  demandeId: number | string | undefined,
  isPartial: boolean | undefined | null,
  emailDetails: any | undefined | null,
  libelle: any | undefined | null,
  source: string | undefined | null,
  commentaireInterne: string | undefined | null,
  associations: any,
  retraitDepot: any | undefined | null,
  pieceJointeSuppl: any,
  updateAdresseLivraison: any | [],
  updateAdresseFacturation: any | [],
): Promise<AnyQueryResponse | undefined> => {
  const formData = new FormData()

  formData.append('panier', JSON.stringify(panier))
  formData.append('isPartial', String(isPartial))
  formData.append('emailDetails', JSON.stringify(emailDetails))
  formData.append('libelle', JSON.stringify(libelle) ?? '')
  formData.append('source', source ?? '')
  formData.append('commentaireInterne', commentaireInterne ?? '')
  formData.append('pieceRetrait', JSON.stringify(associations))
  formData.append('retraitDepot', JSON.stringify(retraitDepot))
  formData.append('updateAdresseLivraison', JSON.stringify(updateAdresseLivraison))
  formData.append('updateAdresseFacturation', JSON.stringify(updateAdresseFacturation))

  pieceJointeSuppl?.forEach((file: File) => {
    formData.append('pieceJointeSuppl[]', file)
  })

  return await axios.post(`${DEMANDE_BASE_URL}/${clientId}/traiter/${demandeId}`, formData)
}

export const postEmailRenvoiPropos = async (
  piecesProposeesModifiees: any | undefined | null,
  piecesProposeesChecked: any | undefined | null,
  piecesAproposees: any | undefined | null,
  piecesReproposees: any | undefined | null,
  clientId: number | string | undefined,
  demandeId: number | string | undefined,
  emailDetails: any | undefined | null,
  panier: any | undefined | null,
  libelle: any | undefined | null,
  source: string | undefined | null,
  commentaireInterne: string | undefined | null,
  associations: any,
  retraitDepot: any | undefined | null,
  pieceJointeSuppl: any,
  updateAdresseLivraison: any | [],
  updateAdresseFacturation: any | [],
): Promise<AnyQueryResponse | undefined> => {
  const formData = new FormData()

  formData.append('piecesProposeesModifiees', JSON.stringify(piecesProposeesModifiees))
  formData.append('piecesProposeesChecked', JSON.stringify(piecesProposeesChecked))
  formData.append('piecesAproposees', JSON.stringify(piecesAproposees))
  formData.append('piecesReproposees', JSON.stringify(piecesReproposees))
  formData.append('emailDetails', JSON.stringify(emailDetails))
  formData.append('panier', JSON.stringify(panier))
  formData.append('libelle', JSON.stringify(libelle) ?? '')
  formData.append('source', source ?? '')
  formData.append('commentaireInterne', commentaireInterne ?? '')
  formData.append('pieceRetrait', JSON.stringify(associations))
  formData.append('retraitDepot', JSON.stringify(retraitDepot))
  formData.append('updateAdresseLivraison', JSON.stringify(updateAdresseLivraison))
  formData.append('updateAdresseFacturation', JSON.stringify(updateAdresseFacturation))

  pieceJointeSuppl?.forEach((file: File) => {
    formData.append('pieceJointeSuppl[]', file)
  })

  return await axios.post(
    `${DEMANDE_BASE_URL}/${clientId}/traiter-renvoi-propos/${demandeId}`,
    formData
  )
}

export const postResendDevis = async (
  clientId: number | string | undefined,
  demandeDevisId: number | string | undefined,
  emailDetails: any | undefined | null
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_BASE_URL}/${clientId}/renvoi-devis/${demandeDevisId}`, {
    emailDetails: emailDetails,
  })
}

export const verifyPieceProposee = (pieces: any) => {
  return axios.post(`${DEMANDE_BASE_URL}/verify/proposee/statut`, {
    pieces,
  })
}

export const dmClosure = async (
  statut: string | undefined,
  client: number | undefined,
  idDemandePiece: number | undefined,
  contactedBy: string | undefined | null,
  isClosure: boolean,
  envoiEmail: boolean
): Promise<any> => {
  const response = await axios.post(`${DEMANDE_BASE_URL}/${client}/closure/${idDemandePiece}`, {
    statut,
    contactedBy,
    isClosure,
    envoiEmail,
  })
  return response.data
}

export const getDemandeProposee = async (
  idClientDemande: number | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(`${DEMANDE_BASE_URL}/demande-proposee/${idClientDemande}`)
}

export const validateSuggestion = async (
  idPieceProposees: any | undefined,
  status: boolean | null | undefined,
  idMotif: number | null | undefined,
  idClient: string | undefined,
  isProspect: boolean | null | undefined,
  demandeId: number | undefined,
  updateClientAdresse: boolean | null | undefined,
  updateAdresseLivraison: any,
  updateAdresseFacturation: any,
  demandeDevisId: number | undefined | null,
  destinataire: string | undefined | null,
  pieceDepot: any,
  commentaireInterne: string | undefined | null,
  paymentIntents: string[] | null = [],
  source: string | undefined | null = null,
  modePaiement: string | undefined | null = null,
  montant: number | null,
  numDevis: string | null,
  viaClient?: boolean,
  retraitDepot?: boolean
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_BASE_URL}/piece/proposee/${idClient}/valider`, {
    status: status,
    motif: idMotif,
    isProspect: isProspect,
    pieces: idPieceProposees,
    demandeId: demandeId,
    updateClientAdresse: updateClientAdresse,
    updateAdresseLivraison: updateAdresseLivraison,
    updateAdresseFacturation: updateAdresseFacturation,
    demandeDevisId: demandeDevisId,
    destinataire: destinataire,
    pieceDepot: pieceDepot,
    commentaireInterne: commentaireInterne,
    // Un PaymentIntent par société : le backend refuse la création des commandes
    // tant que tous ne sont pas encaissés.
    paymentIntents: paymentIntents,
    source: source,
    // cb | virement | en_compte — les règles d'éligibilité sont revérifiées côté serveur.
    modePaiement: modePaiement,
    montant: montant,
    numDevis: numDevis,
    viaClient: viaClient,
    retraitDepot: retraitDepot,
  })
}

export type StripePaiementSociete = {
  societe: 'AUTO' | 'MOTO' | 'INDUSTRIE'
  raisonSociale: string
  publicKey: string
  paymentIntentId: string
  clientSecret: string
  statut: string
  devise: string
  montantTtc: number
  montantPiecesTtc: number
  montantTransportTtc: number
  pieces: number[]
}

export type StripePaiementIntents = {
  demandeId: number
  paiements: StripePaiementSociete[]
  nombreSocietes: number
  montantTotalTtc: number
}

/**
 * Prépare le paiement CB du panier : le backend renvoie un PaymentIntent par
 * société concernée (AUTO / MOTO / INDUSTRIE), chacune sur son propre compte
 * Stripe, avec le montant TTC qui fait foi.
 */
export const createStripePaymentIntents = async (
  demandeId: number | string | undefined,
  clientId: number | string | undefined,
  pieces: number[],
  source: string | undefined | null,
  retraitDepot: boolean | undefined
): Promise<AxiosResponse<StripePaiementIntents>> => {
  return await axios.post(`${PAIEMENT_BASE_URL}/stripe/intent`, {
    demandeId: demandeId,
    clientId: clientId,
    pieces: pieces,
    source: source,
    retraitDepot: retraitDepot,
  })
}

export type PaiementMontantSociete = {
  societe: 'AUTO' | 'MOTO' | 'INDUSTRIE'
  raisonSociale: string
  devise: string
  montantTtc: number
  montantPiecesTtc: number
  montantTransportTtc: number
  pieces: number[]
}

/**
 * Montant dû réparti par société, sans créer de PaymentIntent : le récapitulatif
 * affiché est le même quel que soit le moyen de règlement retenu.
 */
export const getPaiementMontant = async (
  demandeId: number | string | undefined,
  clientId: number | string | undefined,
  pieces: number[],
  source: string | undefined | null,
  retraitDepot: boolean
): Promise<AxiosResponse<{montants: PaiementMontantSociete[]; montantTotalTtc: number}>> => {
  return await axios.post(`${PAIEMENT_BASE_URL}/montant`, {
    demandeId: demandeId,
    clientId: clientId,
    pieces: pieces,
    source: source,
    retraitDepot: retraitDepot,
  })
}

/** Vérifie l'encaissement effectif (le webhook peut arriver après confirmPayment). */
export const getStripePaiementStatut = async (
  paymentIntents: string[]
): Promise<AxiosResponse<any>> => {
  return await axios.post(`${PAIEMENT_BASE_URL}/stripe/statut`, {
    paymentIntents: paymentIntents,
  })
}

export const cancelPieces = async (
  idPieceProposee: any | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_BASE_URL}/piece/proposee/annuler`, {
    pieces: idPieceProposee,
  })
}

export const getNbrePieceAcceptees = async (
  idPieceProposee: string | number | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(`${DEMANDE_BASE_URL}/piece/proposee/${idPieceProposee}`)
}

export const getPieceProposeStatusTotal = async (
  idDemande: string | number | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(`${DEMANDE_BASE_URL}/piece/proposee/status/total/${idDemande}`)
}

export const validatePseudoEmail = async (
  email: string | undefined | null = '',
  pseudo: string | undefined | null = ''
): Promise<any> => {
  if (email) {
    return await axios.post(`${UTILISATEUR_BASE_URL}/validatePseudoEmail`, {email})
  } else if (pseudo) {
    return await axios.post(`${UTILISATEUR_BASE_URL}/validatePseudoEmail`, {pseudo})
  }
}

export const validatePseudoEmailEdit = async (
  email: string | undefined | null = '',
  pseudo: string | undefined | null = '',
  utilisateurId: number | string | undefined
): Promise<any> => {
  if (email) {
    return await axios.post(`${UTILISATEUR_BASE_URL}/${utilisateurId}/validatePseudoEmailEdit`, {
      email,
    })
  } else if (pseudo) {
    return await axios.post(`${UTILISATEUR_BASE_URL}/${utilisateurId}/validatePseudoEmailEdit`, {
      pseudo,
    })
  }
}

export const getQuantityForOneDemandePiece = async (
  idDemande: string | number | undefined,
  idDemandeImmat: string | number | undefined,
  typePiece: string | number | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(`${DEMANDE_BASE_URL}/piece/${idDemande}/${idDemandeImmat}/${typePiece}`)
}

export const searchCatalog = async (
  search: ModeleRechercheCatalogue
): Promise<RechercheCatalogueQueryResponse | undefined> => {
  return await axios.post(`${API_URL}/mdb/catalogue/search`, search)
}

export const exportCatalogue = async (type: string | undefined, data: any): Promise<any> => {
  return await axios.post(`${API_URL}/mdb/catalogue/${type}/export`, data)
}

export const getClientAcomptes = async (
  clientId: string | number | undefined
): Promise<ClientAcomptesQueryResponse> => {
  return await axios.get(`${ACOMPTE_BASE_URL}/${clientId}`)
}
export const getClientDocuments = async (
  clientId: string | undefined
): Promise<ClientDocumentsQueryResponse> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}/documents`)
}
export const getClientsRemises = async (
  clientId: string | number | undefined
): Promise<RemiseQueryResponse> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}/remises`)
}

export const createRemise = async (
  clientId: number | undefined,
  remise: ModeleClientRemise
): Promise<RemiseQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/remise`, remise)
}

export const editRemise = async (
  clientId: number | undefined,
  remiseId: string | undefined,
  remise: ModeleClientRemise
): Promise<RemiseQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_BASE_URL}/${clientId}/${remiseId}/edit`, remise)
}

export const deleteClientDocument = async (
  documentId: string | undefined
): Promise<ClientDocumentQueryResponse | undefined> => {
  return await axios.delete(`${CLIENT_DOCUMENT_BASE_URL}/${documentId}/delete`)
}

export const getClientDocument = async (
  client: string | number | undefined
): Promise<ModeleClientDocument> => {
  const response = await axios.get(`${CLIENT_DOCUMENT_BASE_URL}/${client}`)
  return response.data
}
export const getHistoriqueFacturations = async (
  clientId: string | number | undefined
): Promise<ModeleHistoriqueFacturationResponse> => {
  return await axios.get(`${API_URL}/client-historique-facturation/${clientId}`)
}
export const deleteRemise = async (
  remiseId: string | number | undefined
): Promise<RemiseQueryResponse | undefined> => {
  return await axios.delete(`${CLIENT_BASE_URL}/${remiseId}/delete`)
}

export const getClientDemandeEtape = async (): Promise<any> => {
  return await axios.get(`${CLIENT_DEMANDE_ETAPE_BASE_URL}`)
}

export const getDemandeSource = async (): Promise<any> => {
  return await axios.get(`${DEMANDE_SOURCE_BASE_URL}`)
}

export const getDemontageStatut = async (): Promise<any> => {
  return await axios.get(`${DEMONTAGE_STATUT_BASE_URL}`)
}

export const getCourriels = async (page, search): Promise<any> => {
  const response = await axios.get(`${COURRIEL_BASE_URL}?page=${page}&search=${search}`)
  return response.data
}

export const getCourriel = async (
  idCourriel: string | undefined
): Promise<CourrielQueryResponse> => {
  return await axios.get(`${COURRIEL_BASE_URL}/${idCourriel}`)
}

export const createCourriel = async (
  courriel: ModeleCourriel
): Promise<CourrielQueryResponse | undefined> => {
  return await axios.post(`${COURRIEL_BASE_URL}`, courriel)
}

export const createDemandeDemontage = async (
  demandeDemontage: any
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_DEMONTAGE_BASE_URL}`, demandeDemontage)
}

export const createDemandeTransfertVehicule = async (
  demandeTransfert: ModeleTransfertStatutVehicule
): Promise<DemandeTransfertVehiculeQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_TRANSFERT_STATUT_BASE_URL}`, demandeTransfert)
}

export const getDemandeTransferts = async (
  page?: number | undefined,
  search?: string | undefined,
  dateDebut?: string | undefined,
  dateFin?: string | undefined,
  status?: string | undefined
): Promise<any> => {
  page = page ?? 1
  search = search ?? ''
  dateDebut = dateDebut ?? ''
  status = status ?? ''
  return await axios.get(
    `${DEMANDE_TRANSFERT_STATUT_BASE_URL}?page=${page}&search=${search}&dateDebut=${dateDebut}&dateFin=${dateFin}&status=${status}`
  )
}

export const validateOrRefuseDemandeTransfert = async (
  demandeTransfertId: number | undefined,
  actionDemandeTransfert: ModelActionDemandeTransfert
): Promise<any> => {
  return await axios.post(
    `${DEMANDE_TRANSFERT_STATUT_BASE_URL}/${demandeTransfertId}/traitement`,
    actionDemandeTransfert
  )
}

export const editCourriel = async (
  idCourriel: string | undefined,
  courriel: ModeleCourriel
): Promise<CourrielQueryResponse | undefined> => {
  return await axios.post(`${COURRIEL_BASE_URL}/${idCourriel}/edit`, courriel)
}

export const deleteCourriel = async (
  idCourriel: string | undefined
): Promise<CourrielQueryResponse | undefined> => {
  return await axios.delete(`${COURRIEL_BASE_URL}/${idCourriel}/delete`)
}

export const checkCourrielConnexion = async (
  idCourriel: string | undefined
): Promise<CourrielQueryResponse | undefined> => {
  return await axios.post(`${COURRIEL_BASE_URL}/${idCourriel}/check`)
}

export const getInfoVehicle = async (
  marque: string | undefined | null,
  modele: string | undefined | null
): Promise<any> => {
  return await axios.get(`${DEMANDE_BASE_URL}/info-vehicle?marque=${marque}&modele=${modele}`)
}

export const getOneVehicleModele = async (modele: string | undefined | null): Promise<any> => {
  return await axios.get(`${API_URL}/vehicule/modele/${modele}`)
}

export const getPieceOnMarket = async (
  idPiece: string | undefined,
  refConst: string | undefined,
  signal?: AbortSignal
): Promise<any | undefined> => {
  if (idPiece || refConst) {
    try {
      return await axios.get(`${API_URL}/piece-marche?idPiece=${idPiece}&refConst=${refConst}`, {
        signal,
      })
    } catch (error: unknown) {
      if (error instanceof Error) {
        if (error.name === 'AbortError') {
          console.log('Requête annulée')
        } else {
          console.warn('Erreur lors de la récupération des données :', error.message)
        }
      } else {
        console.error('Erreur inconnue')
      }
      return undefined
    }
  }
}

export const editCentreForDemandeImmat = async (
  clientDemandeId: number | undefined | null,
  immat: string | undefined | null,
  idModele: string | number | undefined | null,
  idVehicleHorsType: string | number | undefined | null,
  centreId: number | undefined | null
): Promise<any> => {
  return await axios.post(`${DEMANDE_IMMAT_BASE_URL}/edit-centre/${centreId}`, {
    clientDemandeId,
    immat,
    idModele,
    idVehicleHorsType,
  })
}

export const editEquipeForDemande = async (
  clientDemandeId: number | undefined | null,
  equipe: number | undefined | null
): Promise<any> => {
  return await axios.post(`${DEMANDE_IMMAT_BASE_URL}/edit-equipe/${clientDemandeId}`, {equipe})
}

export const getKPI = async (filter: string | undefined | null, search: any): Promise<any> => {
  return await axios.get(`${KPI_DEMANDE_BASE_URL}?filter=${filter}&search=${search}`)
}

/* Début groupe remise
 */

export const getGroupesRemises = async (): Promise<any> => {
  return await axios.get(`${REMISE_GROUPE_BASE_URL}`)
}

export const getOneGroupeRemise = async (
  remiseId: string | undefined
): Promise<RemiseQueryResponse> => {
  return await axios.get(`${REMISE_GROUPE_BASE_URL}/${remiseId}`)
}

export const createGroupeRemise = async (
  remise: ModeleRemise
): Promise<RemiseGroupeClientResponse | undefined> => {
  return await axios.post(REMISE_GROUPE_BASE_URL, remise)
}

export const editGroupeRemise = async (
  remiseId: string | undefined,
  remise: ModeleClientRemise
): Promise<RemiseQueryResponse | undefined> => {
  return await axios.post(`${REMISE_GROUPE_BASE_URL}/${remiseId}/edit`, remise)
}

export const deleteGroupeRemise = async (
  remiseId: string | undefined
): Promise<ClientDocumentQueryResponse | undefined> => {
  return await axios.delete(`${REMISE_GROUPE_BASE_URL}/${remiseId}`)
}
/* Fin groupe remise
 */

/* Début client groupe
 */
export const getClientGroupes = async (): Promise<any> => {
  return await axios.get(`${CLIENT_GROUPE_BASE_URL}/all`)
}

export const getOneClientGroupe = async (groupeId: string | undefined): Promise<any> => {
  return await axios.get(`${CLIENT_GROUPE_BASE_URL}/${groupeId}`)
}

export const editClientGroupe = async (
  clientGroupeId: number | string | undefined,
  remise: ModeleClientRemise
): Promise<any> => {
  return await axios.post(`${CLIENT_GROUPE_BASE_URL}/${clientGroupeId}/edit`, remise)
}

export const deleteClientGroupe = async (
  clientGroupeId: number | string | undefined
): Promise<any> => {
  return await axios.delete(`${CLIENT_GROUPE_BASE_URL}/${clientGroupeId}`)
}
/* Fin client groupe
 */

export const getVehicules = async (
  page,
  search,
  marque,
  modele,
  demontage?,
  phase?: string,
  energie?: string,
  puissance?: string,
  vin?: string,
  numero?: number | string,
  immat?: string,
  sites?: string,
  typeEnergie?: string,
  genre?: string,
  typeMoteur?: string,
  typeBoite?: string,
  statut?: string,
): Promise<any> => {
  let response: any
  const params: any = {}
  if (page && page > 0) params.page = page
  if (search && search.trim() !== '') params.search = search
  if (marque && marque.trim() !== '') params.marque = marque
  if (modele && modele.trim() !== '') params.modele = modele
  if (demontage !== undefined) params.demontage = demontage
  if (phase && phase.trim() !== '') params.phase = phase
  if (energie && energie.trim() !== '') params.energie = energie
  if (puissance && puissance.trim() !== '') params.puissance = puissance
  if (vin && vin.trim() !== '') params.vin = vin
  if (numero) params.numero = numero
  if (immat && immat.trim() !== '') params.immat = immat
  if (sites) params.sites = sites
  if (typeEnergie) params.typeEnergie = typeEnergie
  if (genre) params.genre = genre
  if (typeMoteur) params.typeMoteur = typeMoteur
  if (typeBoite) params.typeBoite = typeBoite
  if (statut) params.statut = statut

  response = await axios.get(`${VEHICULE_BASE_URL}/entre`, {params})
  return response.data
}

export const getDemandeDemontage = async (
  page,
  search,
  statut,
  dateDebut,
  dateFin,
  typePiece
): Promise<any> => {
  const response = await axios.get(
    `${DEMANDE_DEMONTAGE_BASE_URL}?page=${page}&search=${search}&statut=${statut}&dateDebut=${dateDebut}&dateFin=${dateFin}&typePiece=${typePiece}`
  )
  return response.data
}

export const getTypePieceDemandeDemontage = async (): Promise<any> => {
  return await axios.get(`${TYPE_PIECE_BASE_URL}/all/typePiece`)
}

export const getMarqueVehicule = async (): Promise<any> => {
  return await axios.get(`${VEHICULE_MODELE_BASE_URL}/all-marque`)
}

export const getModeleVehicule = async (): Promise<any> => {
  return await axios.get(`${VEHICULE_MODELE_BASE_URL}/all-modele`)
}

export const getOneVehicleHorsType = async (id: string | undefined | null): Promise<any> => {
  return await axios.get(`${API_URL}/vehicule/hors-type/${id}`)
}

export const getOneVehicleHorsTypeByMarqueModele = async (
  marque: string | undefined | null,
  modele: string | undefined | null
): Promise<any> => {
  return await axios.get(
    `${API_URL}/vehicule/hors-type/marque-modele?marque=${marque}&modele=${modele}`
  )
}

export const addPieceProp = async (
  demandePieceId: number,
  pieceId: number,
  clientId: number,
  proposeeParId: number | string | undefined | null,
  provenance: string | undefined | null,
  demandeId: number | undefined | null,
  pieceInstance: string | null
): Promise<any> => {
  return await axios.post(`${DEMANDE_BASE_URL}/piece/proposee/add/${demandePieceId}/${pieceId}`, {
    clientId,
    proposeeParId,
    provenance,
    demandeId: demandeId,
    pieceInstance,
  })
}

export const deletePieceInProposee = async (pieceProposeeId: number | undefined): Promise<any> => {
  return await axios.delete(`${DEMANDE_BASE_URL}/piece/proposee/${pieceProposeeId}/delete`)
}

export const createCommentaireClientDemande = async (
  commentaire: ModeleCommentaireClientDemande
): Promise<CommentaireClientDemandeQueryResponse | undefined> => {
  return await axios.post(`${COMMENTAIRE_CLIENT_DEMANDE_BASE_URL}`, commentaire)
}

export const getCommentaireClientDemandeByClientDemandeId = async (
  clientDemandeId: string | number | undefined
): Promise<any> => {
  return await axios.get(`${COMMENTAIRE_CLIENT_DEMANDE_BASE_URL}/${clientDemandeId}`)
}

// Referencement / Referentiel type pièce - Debut
export const importReferenciel = async (file: any): Promise<any> => {
  return await axios.post(`${REFERENCEMENT_TYPE_PIECE_BASE_URL}/import`, file)
}

export const importSite = async (file: any): Promise<any> => {
  return await axios.post(`${REFERENCEMENT_TYPE_PIECE_BASE_URL}/site/import`, file)
}

export const getReferentielsTypePieces = async (page, search): Promise<any> => {
  const response = await axios.get(
    `${REFERENCEMENT_TYPE_PIECE_BASE_URL}?page=${page}&search=${search}`
  )
  return response.data
}

export const getReferentielTypePiece = async (
  idReferentielTypePiece: string | undefined | null,
  idTypePiece: string | undefined | null
): Promise<ReferentielTypePieceQueryResponse> => {
  return await axios.get(
    `${REFERENCEMENT_TYPE_PIECE_BASE_URL}/${idReferentielTypePiece}/${idTypePiece}`
  )
}

export const editReferentielTypePiece = async (
  idReferentielTypePiece: string | undefined | null,
  idTypePiece: string | undefined | null,
  referentielTypePiece: ModeleReferentielTypePiece
): Promise<ReferentielTypePieceQueryResponse | undefined> => {
  return await axios.post(
    `${REFERENCEMENT_TYPE_PIECE_BASE_URL}/${idReferentielTypePiece}/edit/${idTypePiece}`,
    referentielTypePiece
  )
}

export const editMultipleReferentielTypePiece = async (
  typePieces: any,
  sites: any
): Promise<any> => {
  return await axios.post(`${REFERENCEMENT_TYPE_PIECE_BASE_URL}/edit-multiple`, {
    typePieces,
    sites,
  })
}
// Referencement / Referentiel type pièce - Fin

export const checkClientDuplicate = async (data: {
  email?: string
  telephone?: string
  id?: number
}): Promise<{
  emailExists: boolean
  telephoneExists: boolean
}> => {
  const response = await axios.post(`${CLIENT_BASE_URL}/check-duplicate`, data)
  return response.data
}

// Vérification doublons de numéro/email dans SuggestionPage pour éviter l'erreur "Jwt token not Found"
export const checkClientContactDuplicate = async (data: {
  email?: string
  telephone?: string
  id?: number
}): Promise<{
  emailExists: boolean
  telephoneExists: boolean
}> => {
  const response = await axios.post(`${DEMANDE_BASE_URL}/piece/proposee/check-duplicate`, data)
  return response.data
}

export const getResultatAIPiece = async (
  nomTypePiece: string | undefined | null,
  refConst: string | undefined | null,
  marque: string | undefined | null,
  modele: string | undefined | null,
  numSerie: string | undefined | null,
  vin: string | undefined | null,
  datePremCirc: string | undefined | null,
  energie: string | undefined | null,
  version: string | undefined | null
): Promise<AnyQueryResponse> => {
  return await axios.get(
    `${RESULTAT_AI_URL}/gpt/check-oe?typePiece=${nomTypePiece}&ref=${refConst}&marque=${marque}&modele=${modele}&numSerie=${numSerie}&vin=${vin}&datePremCirc=${datePremCirc}&energie=${energie}&version=${version}`
  )
}

export const getOneDemandeImmat = async (
  idDemandeImmat: string | undefined | null
): Promise<AnyQueryResponse> => {
  return await axios.get(`${DEMANDE_IMMAT_BASE_URL}/get-one/${idDemandeImmat}`)
}

export const validationDemandeDemontage = async (
  demandeDemontageValidation: ModeleDemandeDemontage
): Promise<DemandeDemontageResponse | undefined> => {
  return await axios.post(`${DEMANDE_DEMONTAGE_BASE_URL}/validation`, demandeDemontageValidation)
}

export const getReassigner = async (): Promise<any[]> => {
  const response = await axios.get(`${UTILISATEUR_BASE_URL}/reassigner`)
  return response.data
}
export const getOneDemandeDemontage = async (
  demandeDemontageId: string | undefined
): Promise<any> => {
  return await axios.get(`${DEMANDE_DEMONTAGE_BASE_URL}/${demandeDemontageId}`)
}

export const editDemandeDemontage = async (
  demandeDemontageId: string | undefined,
  demandeDemontage: ModeleDemandeDemontage
): Promise<DemandeDemontageQueryResponse | undefined> => {
  return await axios.post(
    `${DEMANDE_DEMONTAGE_BASE_URL}/${demandeDemontageId}/edit`,
    demandeDemontage
  )
}

export const cancelDemandeDemontage = async (
  demandeDemontageId: string | undefined,
  demandeDemontage: ModeleDemandeDemontage
): Promise<DemandeDemontageQueryResponse | undefined> => {
  return await axios.post(
    `${DEMANDE_DEMONTAGE_BASE_URL}/${demandeDemontageId}/cancel`,
    demandeDemontage
  )
}

export const commencerDemandeDemontage = async (
  demandeDemontageId: string | undefined,
  currentUserId: number | string | undefined | null
): Promise<DemandeDemontageQueryResponse | undefined> => {
  return await axios.post(
    `${DEMANDE_DEMONTAGE_BASE_URL}/${demandeDemontageId}/commencer/${currentUserId}`
  )
}

export const getDemandeDemontageInfo = async (
  demandeDemontageId: string | undefined,
  vehiculeId: string | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.get(
    `${DEMANDE_DEMONTAGE_BASE_URL}/${demandeDemontageId}/infoDemandeDemontage/${vehiculeId}`
  )
}

export const postPiecesDemontees = async (
  idDemande: number | string | undefined,
  typePieces: string | undefined | null
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_DEMONTAGE_BASE_URL}/realisationDemontage`, {
    idDemande: idDemande,
    typePieces: typePieces,
  })
}

export const getHistoriqueForOneDemontage = async (
  demandeDemontageId: string | undefined
): Promise<DemandeDemontageQueryResponse | undefined> => {
  return await axios.get(`${HISTORIQUE_DEMONTAGE_BASE_URL}/${demandeDemontageId}/demande-demontage`)
}

export const refuserDemandeDemontage = async (
  idDemande: number | string | undefined,
  typePieces: string | undefined | null,
  motifRefus: string | undefined | null
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${DEMANDE_DEMONTAGE_BASE_URL}/refuserDemontage`, {
    idDemande: idDemande,
    typePieces: typePieces,
    motifRefus: motifRefus,
  })
}
// types pieces pots
export const getPiecePot = async (page, search, dateDebut, dateFin): Promise<any> => {
  const response = await axios.get(
    `${TYPE_PIECE_POT_BASE_URL}?page=${page}&search=${search}&dateDebut=${dateDebut}&dateFin=${dateFin}`
  )
  return response.data
}

export const getReferentielsFournisseursPOT = async (page, search): Promise<any> => {
  const response = await axios.get(
    `${REFERENTIEL_FOURNISSEUR_POT_BASE_URL}?page=${page}&search=${search}`
  )
  return response.data
}

export const getAllFournisseursPOT = async (): Promise<any> => {
  return await axios.get(`${REFERENTIEL_FOURNISSEUR_POT_BASE_URL}/all`)
}

export const getAnomalie = async (): Promise<any> => {
  return await axios.get(`${ANOMALIE_POT_BASE_URL}`)
}

export const getOneFournisseurPOT = async (id: number | string | undefined): Promise<any> => {
  return await axios.get(`${REFERENTIEL_FOURNISSEUR_POT_BASE_URL}/${id}`)
}

export const createFournisseurPOT = async (
  fournisseurPOT: ModeleReferentielFournisseurPOT
): Promise<any> => {
  return await axios.post(REFERENTIEL_FOURNISSEUR_POT_BASE_URL, fournisseurPOT)
}

export const editFournisseurPOT = async (
  fournisseurId: number | string | undefined,
  fournisseur: ModeleReferentielFournisseurPOT
): Promise<any> => {
  return await axios.post(
    `${REFERENTIEL_FOURNISSEUR_POT_BASE_URL}/${fournisseurId}/edit`,
    fournisseur
  )
}

export const deleteFournisseurPOT = async (
  fournisseurId: number | string | undefined
): Promise<any> => {
  return await axios.delete(`${REFERENTIEL_FOURNISSEUR_POT_BASE_URL}/${fournisseurId}/delete`)
}

export const addPot = async (
  demandeId: string | undefined,
  typePieceId: string | undefined,
  demandePieceId: string | undefined,
  pieces: any,
  anomalie: any,
  images: any[],
  provenance: any,
  libelle: any,
  remise: any,
  marge: any,
  isModif: any,
  pieceInstance: any
): Promise<any> => {
  const formData = new FormData()

  if (demandeId) formData.append('demandeId', demandeId)
  if (demandePieceId) formData.append('demandePieceId', demandePieceId)
  if (typePieceId) formData.append('typePieceId', typePieceId)
  formData.append('code', pieces.code)
  formData.append('nom', pieces.nomPiece)
  formData.append('fournisseur', pieces.fournisseur)
  formData.append('prixAchat', pieces.prixAchat)
  formData.append('prixVente', pieces.prixVente)
  formData.append('delai', pieces.delai)
  // formData.append('taxe', pieces.taxe)
  formData.append('anomalie', anomalie)
  formData.append('commandeFournisseur', pieces.commandeFournisseur ?? '')
  formData.append('provenance', provenance)
  formData.append('libelle', libelle)
  formData.append('remise', remise)
  formData.append('marge', marge)
  formData.append('isModif', isModif)
  formData.append('pieceInstance', pieceInstance)

  images.forEach((imgObj) => {
    formData.append('photos[]', imgObj.file)
  })

  return await axios.post(`${TYPE_PIECE_POT_BASE_URL}`, formData)
}

export const updatePot = async (
  typePiecePOT: string | undefined,
  demandeId: string | undefined,
  typePieceId: string | undefined,
  demandePieceId: string | undefined,
  pieces: any,
  anomalie: any,
  images: any[],
  provenance: any,
  libelle: any,
  remise: any,
  marge: any,
  isModif: any
): Promise<any> => {
  const formData = new FormData()

  if (demandeId) formData.append('demandeId', demandeId)
  if (demandePieceId) formData.append('demandePieceId', demandePieceId)
  if (typePieceId) formData.append('typePieceId', typePieceId)
  formData.append('code', pieces.code)
  formData.append('nom', pieces.nomPiece)
  formData.append('fournisseur', pieces.fournisseur)
  formData.append('prixAchat', pieces.prixAchat)
  formData.append('prixVente', pieces.prixVente)
  formData.append('delai', pieces.delai)
  // formData.append('taxe', pieces.taxe)
  formData.append('anomalie', anomalie)
  formData.append('commandeFournisseur', pieces.commandeFournisseur ?? '')
  formData.append('provenance', provenance)
  formData.append('libelle', libelle)
  formData.append('marge', marge)
  formData.append('remise', remise)
  formData.append('isModif', isModif)

  images.forEach((imgObj) => {
    formData.append('photos[]', imgObj.file?.size ? imgObj.file : JSON.stringify(imgObj.file))
  })

  return await axios.post(`${TYPE_PIECE_POT_BASE_URL}/${typePiecePOT}`, formData)
}

export const blockStatutPot = async (
  idDemande: string | number | undefined,
  idPot: string | number | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${TYPE_PIECE_POT_BASE_URL}/nonDisponible`, {
    idDemande: idDemande,
    idPot: idPot,
  })
}

// Client demande message debut

export const createClientDemandeMessage = async (
  idDemande: string | undefined,
  message: string | undefined,
  clientId: number | null | string | undefined
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${CLIENT_DEMANDE_MESSAGE}`, {
    idDemande: idDemande,
    message: message,
    clientId: clientId,
  })
}

export const getClientDemandeMessageByDemandeId = async (
  idDemande: string | undefined,
  signal?: AbortSignal
): Promise<AnyQueryResponse | undefined> => {
  try {
    return await axios.get(`${CLIENT_DEMANDE_MESSAGE}/all-message?idDemande=${idDemande}`, {signal})
  } catch (error: unknown) {
    if (error instanceof Error) {
      if (error.name === 'AbortError') {
        console.log('Requête annulée')
      } else {
        console.warn('Erreur lors de la récupération des données :', error.message)
      }
    } else {
      console.error('Erreur inconnue')
    }
    return undefined
  }
}
// Client demande message fin

export const getAllReseauClients = async () => {
  return await axios.get(`${RESEAU_CLIENT_BASE_URL}/all`)
}

export const getReseauClients = async (page, search, client?): Promise<any> => {
  let response
  if (client === null || client === undefined || client === '') {
    response = await axios.get(`${RESEAU_CLIENT_BASE_URL}?page=${page}&search=${search}`)
  } else {
    response = await axios.get(
      `${RESEAU_CLIENT_BASE_URL}?page=${page}&search=${search}&client=${client}`
    )
  }
  return response.data
}

export const createReseauClient = async (
  reseauClient: ModeleReseauClient
): Promise<ReseauClientQueryResponse | undefined> => {
  return await axios.post(RESEAU_CLIENT_BASE_URL, reseauClient)
}

export const editReseauClient = async (
  reseauClientId: string | undefined,
  reseauClient: ModeleReseauClient
): Promise<ReseauClientQueryResponse | undefined> => {
  return await axios.post(`${RESEAU_CLIENT_BASE_URL}/${reseauClientId}/edit`, reseauClient)
}

export const getReseauClient = async (
  reseauClientId: string | undefined
): Promise<ReseauClientQueryResponse> => {
  return await axios.get(`${RESEAU_CLIENT_BASE_URL}/${reseauClientId}`)
}

export const deleteReseauClient = async (
  reseauClientId: string | undefined
): Promise<ReseauClientQueryResponse | undefined> => {
  return await axios.delete(`${RESEAU_CLIENT_BASE_URL}/${reseauClientId}/delete`)
}

export const affectReseauClient = async (
  client: string | number | undefined,
  reseauClient: string | undefined
): Promise<any> => {
  return await axios.post(`${RESEAU_CLIENT_BASE_URL}/affect/${client}`, {
    reseauClient: reseauClient,
  })
}

export const unaffectReseauClient = async (
  client: string | undefined,
  reseauClient: string | undefined
): Promise<any> => {
  return await axios.delete(`${RESEAU_CLIENT_BASE_URL}/unaffect/${client}/${reseauClient}`)
}

// Début délai traitement
export const getAllTypeDelaisTraitement = async (): Promise<any> => {
  return await axios.get(`${TYPE_DELAIS_TRAITEMENT}`)
}

export const getAllDelaisTraitement = async (): Promise<any> => {
  return await axios.get(`${DELAIS_TRAITEMENT}/all`)
}

export const getDelaisTraitement = async (page: string | number): Promise<any> => {
  return await axios.get(`${DELAIS_TRAITEMENT}?page=${page}`)
}

export const getOneDelaisTraitement = async (delaisTraitement: string | number): Promise<any> => {
  return await axios.get(`${DELAIS_TRAITEMENT}/${delaisTraitement}`)
}

export const verifyActifDelaisTraitement = async (type_delais: string): Promise<any> => {
  return await axios.post(`${DELAIS_TRAITEMENT}/hasActiveDelaiOfType`, {type_delais: type_delais})
}

export const createDelaisTraitement = async (
  delaisTraitement: ModeleDelaisTraitement
): Promise<any> => {
  return await axios.post(`${DELAIS_TRAITEMENT}`, delaisTraitement)
}

export const editDelaisTraitement = async (
  delaisTraitementId: string | number,
  delaisTraitement: ModeleDelaisTraitement
): Promise<any> => {
  return await axios.post(`${DELAIS_TRAITEMENT}/${delaisTraitementId}/edit`, delaisTraitement)
}

export const deleteDelaisTraitement = async (
  delaisTraitementId: string | number | undefined
): Promise<any> => {
  if (delaisTraitementId !== undefined) {
    return await axios.delete(`${DELAIS_TRAITEMENT}/${delaisTraitementId}/delete`)
  }
}
// Fin délai traitement
export const getAllActions = async (
  page: number | string | undefined,
  search: string | undefined,
  statut: string | undefined,
  type: string | undefined,
  origine: string | undefined,
  dateMin: string | undefined,
  dateMax: string | undefined,
  mesActions: boolean | undefined,
  vue: string | undefined
): Promise<any> => {
  const response = await axios.get(
    `${MES_ACTIONS_BASE_URL}?page=${page}&search=${search}&statut=${statut}&type=${type}&origine=${origine}&dateMin=${dateMin}&dateMax=${dateMax}&mesActions=${mesActions}&vue=${vue}`
  )
  return response.data
}

export const createMesActions = async (mesActions: ModeleMesActions): Promise<any> => {
  return await axios.post(`${MES_ACTIONS_BASE_URL}/new`, mesActions)
}

// Pour les messages télévendeurs
export const createMessTelevendeur = async (demandeId, clientId, commentaire): Promise<any> => {
  return await axios.post(`${MES_ACTIONS_BASE_URL}/new/mess-televendeur/${demandeId}/${clientId}`, {
    commentaire: commentaire,
  })
}

export const readMesActions = async (mesActions: ModeleMesActions): Promise<any> => {
  return await axios.post(`${MES_ACTIONS_BASE_URL}/${mesActions.id}/read`)
}

export const startActions = async (mesActions: ModeleMesActions): Promise<any> => {
  return await axios.post(`${MES_ACTIONS_BASE_URL}/${mesActions.id}/start`)
}

export const finishActions = async (mesActions: ModeleMesActions): Promise<any> => {
  return await axios.post(`${MES_ACTIONS_BASE_URL}/${mesActions.id}/finish`, mesActions)
}

export const createTypesActions = async (typesActions: ModeleTypeAction): Promise<any> => {
  return await axios.post(`${TYPE_ACTIONS_BASE_URL}/new`, typesActions)
}

export const deleteTypeActions = async (typeId: number | string | undefined): Promise<any> => {
  return await axios.delete(`${TYPE_ACTIONS_BASE_URL}/${typeId}/delete`)
}

export const getTypeActions = async (): Promise<TypeActionsQueryResponse> => {
  return await axios.get(`${TYPE_ACTIONS_BASE_URL}`)
}

export const editTypesActions = async (
  typeId: number | string | undefined,
  modeleType: ModeleTypeAction
): Promise<any> => {
  return await axios.post(`${TYPE_ACTIONS_BASE_URL}/${typeId}/edit`, modeleType)
}

export const getOneTypesActions = async (id: number | string | undefined): Promise<any> => {
  return await axios.get(`${TYPE_ACTIONS_BASE_URL}/${id}`)
}

export const getTypesActionsPg = async (page): Promise<any> => {
  const response = await axios.get(`${TYPE_ACTIONS_BASE_URL}/list?page=${page}`)
  return response.data
}

export const getStatutActions = async (): Promise<StatutActionsQueryResponse> => {
  return await axios.get(`${STATUT_ACTIONS_BASE_URL}`)
}

export const getOneAction = async (id: number | string | undefined): Promise<any> => {
  return await axios.get(`${MES_ACTIONS_BASE_URL}/${id}`)
}

export const editAction = async (
  actionId: number | string | undefined,
  action: ModeleMesActions
): Promise<any> => {
  return await axios.post(`${MES_ACTIONS_BASE_URL}/${actionId}/edit`, action)
}

export const updateStatutAction = async (
  actionId: number | string | undefined,
  codeStatut: string | undefined
): Promise<any> => {
  return await axios.post(`${MES_ACTIONS_BASE_URL}/${actionId}/updateStatut`, {
    codeStatut: codeStatut,
  })
}

export const deleteAction = async (actionId: number | string | undefined): Promise<any> => {
  return await axios.delete(`${MES_ACTIONS_BASE_URL}/${actionId}/delete`)
}

export const getMesActions = async (userId: number | string | undefined): Promise<any> => {
  return await axios.get(`${MES_ACTIONS_BASE_URL}/user/${userId}`)
}

export const realiserAction = async (
  idAction: number | string | undefined,
  statutCode: string | undefined | null
): Promise<AnyQueryResponse | undefined> => {
  return await axios.post(`${MES_ACTIONS_BASE_URL}/${idAction}/realiser`, {
    statut: statutCode,
  })
}

export const checkDispoPiece = async (pieceId: number | string | undefined): Promise<any> => {
  return await axios.get(`${API_URL}/wspiececode/${pieceId}`)
}

export const checkDispoPieceLocal = async (pieceId: number | string | undefined): Promise<any> => {
  return await axios.get(`${API_URL}/isfreelocal/${pieceId}`)
}

export const getPieceMarchePrix = async (refConst: number | string | undefined): Promise<any> => {
  return await axios.get(`${PIECE_MARCHE_BASE_URL}/prix?refConst=${refConst}`)
}

export const getDetailsPiece = async (codePiece: number | string | undefined): Promise<any> => {
  return await axios.get(`${PRIX_MODIF_BASE_URL}/detailsPrix?codePiece=${codePiece}`)
}

export const getCountByState = async (
  allDemandes: boolean | null | undefined,
  clientId: number | null | undefined,
  centreId: string | null | undefined,
  demandeEquipe: string | null | undefined
): Promise<any> => {
  return await axios.get(`${DEMANDE_BASE_URL}/count-by-stat`, {
    params: {
      allDemandes: allDemandes,
      clientId: clientId,
      centreId: centreId,
      demandeEquipe: demandeEquipe,
    },
  })
}

export const getAllTypeLibelleDemande = async (): Promise<any> => {
  return await axios.get(`${TYPE_LIBELLE_DEMANDE}`)
}

export const postLibelleDemandePiece = async (
  libelleDemandePiece: ModeleLibelleDemandePiece,
  idDemande: any
): Promise<any> => {
  return await axios.post(`${LIBELLE_DEMANDE_PIECE}/add/${idDemande}`, {
    libelleDemandePiece: libelleDemandePiece,
  })
}

export const getLibelleDemandePiece = async (idDemande: any): Promise<any> => {
  return await axios.get(`${LIBELLE_DEMANDE_PIECE}/get/${idDemande}`)
}

export const deleteLibelleDemandePiece = async (
  idLibelleDemandePiece: number | null | undefined
): Promise<any> => {
  return await axios.delete(`${LIBELLE_DEMANDE_PIECE}/delete/${idLibelleDemandePiece}`)
}

export const editLibelleDemandePiece = async (
  libelleDemandePiece: ModeleLibelleDemandePiece
): Promise<any> => {
  return await axios.put(`${LIBELLE_DEMANDE_PIECE}/edit/${libelleDemandePiece.id}`, {
    libelleDemandePiece: libelleDemandePiece,
  })
}

export const getCommentByPiece = async (
  idPieceProposee: number | null | undefined
): Promise<any> => {
  return await axios.get(`${PIECE_COMMENTAIRE}/${idPieceProposee}/get`)
}

export const addCommentairePieceProposee = async (
  idPieceProposee: number | null | undefined,
  message: any,
  idAuthor: number | null | undefined
): Promise<any> => {
  return await axios.post(`${PIECE_COMMENTAIRE}/${idPieceProposee}/add`, {
    message: message,
    author: idAuthor,
  })
}

export const changeStatutProposee = async (
  idPieceProposee: number | null | undefined,
  demande: number | null | undefined,
  panier: any | undefined
): Promise<any> => {
  return await axios.post(
    `${CLIENT_DEMANDE_PIECE_PROPOSEE}/${idPieceProposee}/${demande}/changeStatutProposee`,
    {
      panier: panier,
    }
  )
}

// debut gestion provenance
export const getProvenances = async (page: string | number): Promise<any> => {
  return await axios.get(`${PROVENANCES_PIECE}/all-provenance?page=${page}`)
}
export const createProvenance = async (provenances: ModeleProvenance): Promise<any> => {
  return await axios.post(`${PROVENANCES_PIECE}`, provenances)
}
export const editProvenance = async (
  provenanceId: string | number,
  provenances: ModeleProvenance
): Promise<any> => {
  return await axios.post(`${PROVENANCES_PIECE}/${provenanceId}/edit`, provenances)
}

export const deleteProvenance = async (provenanceId: string | number | undefined): Promise<any> => {
  if (provenanceId !== undefined) {
    return await axios.delete(`${PROVENANCES_PIECE}/${provenanceId}/delete`)
  }
}
// fin gestion provenance

// début gestion équipe
export const getEquipes = async (page: string | number, searchTerm: string): Promise<any> => {
  return await axios.get(`${EQUIPES_URL}/liste?page=${page}&searchTerm=${searchTerm}`)
}
export const getEquipe = async (equipeId: string | number | undefined): Promise<any> => {
  return await axios.get(`${EQUIPES_URL}/${equipeId}`)
}
export const createEquipe = async (equipes: ModeleProvenance): Promise<any> => {
  return await axios.post(`${EQUIPES_URL}/ajouter`, equipes)
}

export const editEquipe = async (
  equipeId: string | number,
  equipes: ModeleProvenance
): Promise<any> => {
  return await axios.post(`${EQUIPES_URL}/${equipeId}/modifier`, equipes)
}

export const deleteEquipe = async (equipeId: string | number | undefined): Promise<any> => {
  if (equipeId !== undefined) {
    return await axios.delete(`${EQUIPES_URL}/${equipeId}/supprimer`)
  }
}

export const horaireEquipe = async (
  equipeId: string | number | undefined,
  heureDebut: string,
  heureFin: string,
  heureDebutPause: string | null | undefined,
  heureFinPause: string | null | undefined,
  specificDay: any
): Promise<any> => {
  return await axios.put(`${EQUIPES_URL}/configurer-horaire`, {
    equipeIds: equipeId,
    heureDebut: heureDebut,
    heureFin: heureFin,
    heureDebutPause: heureDebutPause,
    heureFinPause: heureFinPause,
    specificDay: specificDay,
  })
}
// fin gestion équipe

// début gestion article
export const getArticles = async (page: string | number): Promise<any> => {
  return await axios.get(`${TYPE_LIBELLE_DEMANDE}/liste?page=${page}`)
}

export const createArticle = async (article: ModeleArticle): Promise<any> => {
  return await axios.post(`${TYPE_LIBELLE_DEMANDE}/ajouter`, article)
}

export const editArticle = async (
  articleId: string | number,
  article: ModeleArticle
): Promise<any> => {
  return await axios.post(`${TYPE_LIBELLE_DEMANDE}/${articleId}/modifier`, article)
}

export const deleteArticle = async (articleId: string | number | undefined): Promise<any> => {
  if (articleId !== undefined) {
    return await axios.delete(`${TYPE_LIBELLE_DEMANDE}/${articleId}/supprimer`)
  }
}
// fin gestion article

// début gestion dépôt
export const getDepots = async (page: string | number): Promise<any> => {
  return await axios.get(`${DEPOT_URL}/liste?page=${page}`)
}

export const createDepot = async (depot: ModeleDepot): Promise<any> => {
  return await axios.post(`${DEPOT_URL}/ajouter`, depot)
}

export const editDepot = async (depotId: string | number, depot: ModeleDepot): Promise<any> => {
  return await axios.put(`${DEPOT_URL}/${depotId}/modifier`, depot)
}

export const deleteDepot = async (depotId: string | number | undefined): Promise<any> => {
  if (depotId !== undefined) {
    return await axios.delete(`${DEPOT_URL}/${depotId}/supprimer`)
  }
}
// fin gestion dépôt

//debut gestion source
export const getSources = async (): Promise<any> => {
  return await axios.get(`${SOURCE_BASE_URL}`)
}
//fin gestion source

export const getProvenancePiece = async (filter = true): Promise<any> => {
  return await axios.get(`${PROVENANCES_PIECE}?filter=${filter}`)
}

export const updateProvenancePiece = async (
  idClientDemandePieceProposee: number | undefined,
  provenanceId: number | undefined
): Promise<any> => {
  return await axios.patch(
    `${CLIENT_DEMANDE_PIECE_PROPOSEE}/edit/provenance/${idClientDemandePieceProposee}`,
    {
      provenance: provenanceId,
    }
  )
}

export const getAdresseFacturationData = async (
  clientId: string | number | undefined | null
): Promise<any> => {
  return await axios.get(`${CLIENT_BASE_URL}/${clientId}/adresse-facturation`)
}

export const exportPrix = async (data: any): Promise<any> => {
  return await axios.post(`${PRIX_MODIF_BASE_URL}/export`, data)
}

export const changeClientOnDemande = async (
  clientId: number | null | undefined,
  demandeId: number | null | undefined,
  contactType: string | null | undefined,
  choicedContact: number | null | undefined,
  communicationMode: string | null | undefined,
  idsPieceProposee: any
): Promise<any> => {
  return await axios.patch(`${CLIENT_BASE_URL}/${clientId}/change-client/${demandeId}`, {
    choicedContact: choicedContact,
    communicationMode: communicationMode,
    contactType: contactType,
    idsPieceProposee: idsPieceProposee,
  })
}

export const getSiteAll = async (): Promise<any> => {
  const response = await axios.get(`${PRIX_MODIF_BASE_URL}/site`)
  return response.data
}

export const getEquipeUtilisateur = async (): Promise<any> => {
  return await axios.get(`${EQUIPES_URL}/all-equipes`)
}

export const getAllEquipes = async (): Promise<any> => {
  const response = await axios.get(`${EQUIPES_URL}`)
  return response.data
}

export const getRefOe = async (reference, codePiece): Promise<any> => {
  return await axios.get(
    `${PRIX_MODIF_BASE_URL}/all-refOe?reference=${reference}&codePiece=${codePiece}`
  )
}

export const getAdresseDepotBySourceDemande = async (
  source: string,
  signal?: AbortSignal
): Promise<any> => {
  return await axios.get(`${DEMANDE_BASE_URL}/retrait-depot/${source}`, {signal})
}

export const confirmVB = async (idDemande: string, statut: string): Promise<any> => {
  return await axios.post(`${CLIENT_DEMANDE_PIECE_PROPOSEE}/confirm-vb/${idDemande}`, {
    statut: statut,
  })
}

export const updatePieceDemontage = async (
  idPieceProposee: number | undefined,
  idPieceEntree: number | undefined,
  idDemande: number | undefined
): Promise<any> => {
  return await axios.post(
    `${CLIENT_DEMANDE_PIECE_PROPOSEE}/${idPieceProposee}/liaisonPieceDemonter`,
    {
      idPieceEntree: idPieceEntree,
      idDemande: idDemande,
    }
  )
}

export const refusDemontage = async (
  idPieceProposee: number | undefined,
  idDemande: number | undefined,
  panier: any
): Promise<any> => {
  return await axios.post(
    `${CLIENT_DEMANDE_PIECE_PROPOSEE}/${idPieceProposee}/refus/${idDemande}`,
    {
      panier: panier,
    }
  )
}

export const createFilterFavoris = async (
  utilisateur: number,
  filterData: any,
  filterTitle: string
): Promise<any> => {
  return await axios.post(`${FILTER_BASE_URL}/create/${utilisateur}`, {
    filterData: filterData,
    filterTitle: filterTitle,
  })
}

export const getFilterFavoris = async (utilisateur: number): Promise<any> => {
  return await axios.get(`${FILTER_BASE_URL}/get/${utilisateur}`)
}

export const deleteFavoris = async (favorisId: string | undefined): Promise<any> => {
  return await axios.delete(`${FILTER_BASE_URL}/delete/${favorisId}`)
}

export const activateFavori = async (
  utilisateurId: string | number,
  favorisId: string | undefined,
  actif: boolean
): Promise<any> => {
  return await axios.put(
    `${FILTER_BASE_URL}/activate-favori/${utilisateurId}/${favorisId}/${actif}`
  )
}

export const updateFavori = async (
  favorisId: number | undefined,
  userId: number,
  filterData: any
): Promise<any> => {
  return await axios.put(`${FILTER_BASE_URL}/update-favori/${userId}/${favorisId}`, {
    filterData: filterData,
  })
}

// Service Rattachement - Début
export const getAllServiceRattachements = async (): Promise<any> => {
  return await axios.get(`${SERVICE_RATTACHEMENT_URL}/all`)
}

export const getServiceRattachements = async (page: number): Promise<any> => {
  return await axios.get(`${SERVICE_RATTACHEMENT_URL}/liste?page=${page}`)
}

export const getServiceRattachement = async (
  serviceRattachementId: string | undefined
): Promise<any> => {
  return await axios.get(`${SERVICE_RATTACHEMENT_URL}/${serviceRattachementId}`)
}

export const createServiceRattachement = async (libelle: string, image: any): Promise<any> => {
  return await axios.post(
    `${SERVICE_RATTACHEMENT_URL}/ajouter`,
    {
      libelle: libelle,
      image: image,
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

export const editServiceRattachement = async (
  serviceRattachementId: number,
  libelle: string,
  image: any
): Promise<any> => {
  return await axios.post(
    `${SERVICE_RATTACHEMENT_URL}/${serviceRattachementId}/modifier`,
    {
      libelle: libelle,
      image: image,
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

export const deleteServiceRattachement = async (
  serviceRattachementId: number | undefined
): Promise<any> => {
  return await axios.delete(`${SERVICE_RATTACHEMENT_URL}/${serviceRattachementId}/supprimer`)
}
// Service Rattachement - Fin

// Filtre et Favori pour Tarification - Debut
export const createFavoriModifPrix = async (
  utilisateur: number | undefined,
  filterData: any,
  filterTitle: string
): Promise<any> => {
  return await axios.post(`${MODIF_PRIX_FILTER_BASE_URL}/create/${utilisateur}`, {
    filterData: filterData,
    filterTitle: filterTitle,
  })
}

export const getFavoriModifPrix = async (utilisateur: number | undefined): Promise<any> => {
  return await axios.get(`${MODIF_PRIX_FILTER_BASE_URL}/get/${utilisateur}`)
}

export const deleteFavoriModifPrix = async (favorisId: string | undefined): Promise<any> => {
  return await axios.delete(`${MODIF_PRIX_FILTER_BASE_URL}/delete/${favorisId}`)
}

export const activateFavoriModifPrix = async (
  utilisateurId: number | undefined,
  favorisId: string | undefined,
  actif: boolean
): Promise<any> => {
  return await axios.put(
    `${MODIF_PRIX_FILTER_BASE_URL}/activate-favori/${utilisateurId}/${favorisId}/${actif}`
  )
}

export const updateFavoriModifPrix = async (
  favorisId: number | undefined,
  filterData: any,
  filterTitle: string | null
): Promise<any> => {
  return await axios.put(`${MODIF_PRIX_FILTER_BASE_URL}/update-favori/${favorisId}`, {
    filterData: filterData,
    filterTitle: filterTitle,
  })
}
// Filtre et Favori pour Tarification - Fin

// Groupe LIBPR - Début
export const getAllGroupeLIBPRs = async (): Promise<any> => {
  return await axios.get(`${GROUPE_LIBPR_URL}/all`)
}

export const getGroupeLIBPRs = async (page: number): Promise<any> => {
  return await axios.get(`${GROUPE_LIBPR_URL}/liste?page=${page}`)
}

export const getGroupeLIBPR = async (groupeLibprId: string | undefined): Promise<any> => {
  return await axios.get(`${GROUPE_LIBPR_URL}/${groupeLibprId}`)
}

export const createGroupeLIBPR = async (
  libelle: string,
  typePieces: any,
  description: string
): Promise<any> => {
  const formData = new FormData()

  if (libelle) formData.append('libelle', libelle)
  if (typePieces) formData.append('typePieces', JSON.stringify(typePieces))
  if (description) formData.append('description', description)

  return await axios.post(`${GROUPE_LIBPR_URL}/ajouter`, formData)
}

export const editGroupeLIBPR = async (
  groupeLibprId: number,
  libelle: string,
  typePieces: any,
  description: string
): Promise<any> => {
  const formData = new FormData()

  if (libelle) formData.append('libelle', libelle)
  if (typePieces) formData.append('typePieces', JSON.stringify(typePieces))
  if (description) formData.append('description', description)

  return await axios.post(`${GROUPE_LIBPR_URL}/${groupeLibprId}/modifier`, formData)
}

export const deleteGroupeLIBPR = async (groupeLibprId: number | undefined): Promise<any> => {
  return await axios.delete(`${GROUPE_LIBPR_URL}/${groupeLibprId}/supprimer`)
}
// Groupe LIBPR - Fin

//get site véhicule par immatriculation
export const getSiteVehiculeImmat = async (
  donneesImmatriculation: string | number | undefined | null
): Promise<any> => {
  return await axios.get(`${VEHICULE_BASE_URL}/siteImmat/${donneesImmatriculation}`)
}

//get site véhicule par marque et modele
export const getSiteVehicule = async (modele: string | undefined | null): Promise<any> => {
  return await axios.get(`${VEHICULE_BASE_URL}/site/${modele}`)
}

export const activedPOT = async (clientDemandePieceProposee): Promise<any> => {
  return await axios.get(`${DEMANDE_BASE_URL}/activedPOT/${clientDemandePieceProposee}`)
}

export const getTypeEnergie = async (): Promise<any> => {
  const response = await axios.get(`${DEMANDE_DEMONTAGE_BASE_URL}/type-energie`)
  return response.data
}

export const getGenreVehicule = async (): Promise<any> => {
  const response = await axios.get(`${DEMANDE_DEMONTAGE_BASE_URL}/getGenre`)
  return response.data
}

export const getStatutVehicule = async (): Promise<any> => {
  const response = await axios.get(`${DEMANDE_DEMONTAGE_BASE_URL}/statut-vehicule`)
  return response.data
}

